import React from 'react'

export default function NotFound() {
  return (
    <div className={"login-div-center"}>
      404 NOT FOUND
    </div>
  );
}
